<template>
  <VcInputBottomSheet
    :value="isOpen"
    :footer="false"
    :title="emptyTitle"
    :show-header-divider="false"
    :persistent="false"
    data-qa="platform-profile-panel-root"
    @input="onSheetInput">
    <template #activator="{ on, attrs }">
      <span
        class="platform-profile-panel__activator"
        v-bind="attrs"
        v-on="on"
        aria-hidden="true"
      />
    </template>
    <div class="platform-profile-panel" data-qa="platform-profile-panel">
      <div class="platform-profile-panel__header">
        <VcAvatar
          :name="userName"
          :color-id="colorId"
          :image-path="imagePath"
          size="lg"
          data-qa="profile-panel-avatar" />
        <div class="platform-profile-panel__user-info">
          <span class="platform-profile-panel__name" data-qa="profile-panel-name">
            {{ userName }}
          </span>
          <span class="platform-profile-panel__email" data-qa="profile-panel-email">
            {{ email }}
          </span>
        </div>
      </div>

      <nav class="platform-profile-panel__items" data-qa="profile-panel-items">
        <button
          v-for="item in accountItems"
          :key="item.event"
          type="button"
          class="platform-profile-panel__item"
          :data-qa="`profile-panel-item-${item.event}`"
          @click="$emit('item-click', item)">
          <VcIcon v-if="item.icon" size="20" color="currentColor">{{ item.icon }}</VcIcon>
          <span>{{ getItemLabel(item) }}</span>
        </button>
        <button
          type="button"
          class="platform-profile-panel__item platform-profile-panel__item--logout"
          data-qa="profile-panel-logout"
          @click="$emit('logout')">
          <VcIcon size="20" color="currentColor">icon-Logout_POV</VcIcon>
          <span>{{ logoutLabel }}</span>
        </button>
      </nav>
    </div>
  </VcInputBottomSheet>
</template>

<script>
import VcInputBottomSheet from '@vcita/design-system/src/components/VcInputBottomSheet/VcInputBottomSheet.vue';

export default {
  name: 'PlatformProfilePanel',
  components: {
    VcInputBottomSheet,
  },
  props: {
    isOpen: { type: Boolean, default: false },
    userName: { type: String, default: '' },
    email: { type: String, default: '' },
    colorId: { type: Number, default: 27 },
    imagePath: { type: String, default: '' },
    accountItems: { type: Array, default: () => [] },
    logoutLabel: { type: String, default: 'Log out' },
  },
  data() {
    return {
      emptyTitle: ' ',
    };
  },
  methods: {
    getItemLabel(item) {
      return item.translationKey ? this.$t(item.translationKey) : item.label;
    },
    onSheetInput(open) {
      if (!open) {
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.platform-profile-panel__activator {
  position: fixed;
  left: 0;
  top: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  opacity: 0;
}

.platform-profile-panel {
  width: 100%;
  max-height: 85dvh;
  display: flex;
  flex-direction: column;
  position: relative;
  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--size-value2);
    padding: 0 var(--size-value4) var(--size-value10);
  }

  &__user-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
  }

  &__name {
    font-size: var(--font-size-medium);
    font-weight: var(--font-weight-large);
    color: var(--text-color-primary);
  }

  &__email {
    font-size: var(--font-size-small2);
    font-weight: var(--font-weight-medium2);
    color: var(--text-secondary-62, var(--gray-darken-4));
  }

  &__items {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: var(--size-value2) var(--size-value2) var(--size-value4);
    overflow-y: auto;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: var(--size-value3);
    padding: var(--size-value3) var(--size-value3);
    background: none;
    border: none;
    border-bottom: 1px solid rgba(15, 23, 42, 0.06);
    border-radius: 0;
    cursor: pointer;
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-medium2);
    color: var(--text-color-primary);
    text-align: start;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: var(--neutral-lighten-2);
    }

    &--logout {
      color: var(--error);
      border-bottom: none;
    }
  }
}
</style>

<style lang="scss">
[data-qa='platform-profile-panel-root-sheet'] .vc-bottom-sheet__content {
  padding: 0 !important;
}
</style>
